import {
  Root,
  Trigger,
  Content,
  Item,
  Viewport,
  Link as RadixLink,
} from '@radix-ui/react-navigation-menu'
import type { HeaderLink } from '@cms/data/getHeaderData'
import { Link } from '@components/Link'
import { LinkForAppFeatures } from '@components/LinkForAppFeatures'
import { HEADER_SNOWPLOW_NAVIGATION_CLICK } from '@components/Header'
import { useEventTracker } from '@hooks/useEventTracker'

type NavigationMenuProps = {
  label: string
  links: Array<HeaderLink>
}

export const NavigationMenu = ({ label, links }: NavigationMenuProps) => {
  const { track } = useEventTracker()

  return (
    <Root>
      <Item className='list-none'>
        <Trigger className='outline-teal'>
          <div className='text-neutral text-18 font-regular m-12 cursor-pointer hover:bg-neutral focus:outline-teal focus:border-none'>
            {label}
          </div>
        </Trigger>
        <Content className='bg-neutral shadow-4 w-max rounded-lg mt-8 p-12 flex flex-col'>
          {links.map(link => (
            <div
              key={`${link.label}-${link.href}}`}
              className='p-4 m-8 hover:bg-neutral-alternate rounded-lg'
            >
              <RadixLink asChild>
                {/* We need to localise the BlogCategory url */}
                {link.featureType === 'BlogCategory' ? (
                  <LinkForAppFeatures
                    type='BlogCategory'
                    slug={link.href}
                    className='font-sans font-medium text-teal text-14 focus:outline-teal'
                    onClick={() => {
                      track({
                        action: HEADER_SNOWPLOW_NAVIGATION_CLICK,
                        label: link.href,
                      })
                    }}
                  >
                    {link.label}
                  </LinkForAppFeatures>
                ) : (
                  <Link
                    url={link.href}
                    className='font-sans font-medium text-teal text-14 focus:outline-teal'
                    onClick={() => {
                      track({
                        action: HEADER_SNOWPLOW_NAVIGATION_CLICK,
                        label: link.href,
                      })
                    }}
                  >
                    {link.label}
                  </Link>
                )}
              </RadixLink>
            </div>
          ))}
        </Content>
        <div className='absolute top-full'>
          <Viewport />
        </div>
      </Item>
    </Root>
  )
}
